var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"com-rankname flex ai-c jc-fs",on:{"click":_vm.postStat}},[_c('div',{class:['com-rankname-rank', `com-rankname-rank-${_vm.option.rank}`]},[_vm._v(_vm._s(_vm.option.rank))]),_c('div',{staticClass:"com-rankname-info"},[_c('div',{class:{
        'com-rankname-info-name': true,
        'com-rankname-fitline': _vm.option.stockCode,
        'com-rankname-minsize': _vm.option.name.length > 5,
        ellipsis: _vm.option.stockCode && _vm.option.name.length > 5,
      }},[_vm._v(" "+_vm._s(_vm.option.name)+" ")]),(_vm.option.stockCode)?_c('div',{staticClass:"com-rankname-info-code"},[_c('span'),_vm._v(_vm._s(_vm.option.stockCode))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }